var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-media-links"},[_c('BaseLink',_vm._b({staticClass:"link--facebook"},'BaseLink',_vm.links,false)),_vm._v(" "),_c('GoogleSignIn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }